var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnExh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#05B88D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.81 7.65V10.03H8.37V11.1H9.81V14.37H11.13V7.65H9.81ZM8.34 13.18L8.98 12.15C7.53 11.67 6.9 10.53 6.9 9.44V9.32H8.69V8.27H3.74V9.32H5.55V9.45C5.55 10.6 4.9 11.83 3.38 12.31L4.04 13.36C5.12 13 5.84 12.28 6.25 11.36C6.64 12.2 7.33 12.85 8.34 13.18ZM11.34 16.7V15.65H6.38V13.81H5.06V16.7H11.34ZM19.7592 16.88V7.64H18.4392V16.88H19.7592ZM15.6992 9.7V8.36H14.3792V9.7C14.3792 11.5 13.6192 13.26 12.0092 13.96L12.7992 15.05C13.9292 14.53 14.6492 13.56 15.0592 12.31C15.4692 13.44 16.1592 14.35 17.2392 14.83L17.9892 13.76C16.4292 13.09 15.6992 11.41 15.6992 9.7Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnExh);
export default __webpack_public_path__ + "static/media/btnExh.dc383454f174d2d366e7a65f8832132c.svg";
export { ForwardRef as ReactComponent };